
const CalendarIcon = () => (
  <img src="/images/icon-calendar.png" alt="Calendar" />
);

export default CalendarIcon;